import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ConfirmModal } from '@apply/ui';
import { CreateBudgetModal } from './CreateBudgetModal';
import { saveStages } from '../';
import { createBudget } from '../../../common/functions/draws/createBudget';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil, faDownload } from '@fortawesome/free-solid-svg-icons';
import { getDrawBudgetURL } from '../../../common/LoanFunctions';
import { ProblemPropertyIndicator } from './ProblemPropertyIndicator';

export const NoBudgetDrawPanel = ({ property, styles, validateSubmission, onProblemPropertyChange }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isSaveModalOpen, set_isSaveModalOpen] = useState<boolean>(false);
    const [saveBeforeCreating, set_saveBeforeCreating] = useState<boolean>(false);
    const [isCreateBudgetModalOpen, set_isCreateBudgetModalOpen] = useState<boolean>(false);

    const confirmSaveModal = async () => {
        set_saveBeforeCreating(true);
        set_isSaveModalOpen(false);
        set_isCreateBudgetModalOpen(true);
    };

    const cancelSaveModal = async () => {
        set_saveBeforeCreating(false);
        set_isSaveModalOpen(false);
        set_isCreateBudgetModalOpen(true);
    };

    const openCreateBudgetModal = async () => {
        set_isSaveModalOpen(true);
    };

    const emptyBudgetCallback = async () => {
        set_isCreateBudgetModalOpen(false);
        if (saveBeforeCreating) {
            await validateSubmission(null, saveStages.createEmptyBudget, property);
        } else {
            await createBudgetWithRedirect(false);
        }
    };

    const populatedBudgetCallback = async () => {
        set_isCreateBudgetModalOpen(false);
        if (saveBeforeCreating) {
            await validateSubmission(null, saveStages.createPopulatedBudget, property);
        } else {
            await createBudgetWithRedirect(true);
        }
    };

    const createBudgetWithRedirect = async (isPopulated: boolean) => {
        const newBudget = await createBudget(property.id, isPopulated);
        if (newBudget) {
            navigate(getDrawBudgetURL(newBudget, location));
        }
    };

    const onCreateBudgetModalClose = async () => {
        set_isCreateBudgetModalOpen(false);
    };

    const onDownloadBudget = async () => {
        window.location.href = property.budgetFileUrl;
    };

    return (
        <div style={styles.displayFlex}>
            <p>Setup Budget</p>
            <div style={styles.iconButton}>
                <button
                    type='button'
                    onClick={openCreateBudgetModal}
                    className='button hollow'
                    title='Create Budget'
                >
                    <FontAwesomeIcon icon={faPencil} />
                </button>
            </div>
            {property.budgetFileUrl && (
                <>
                    <p>Borrower Submission</p>
                    <div style={styles.iconButton}>
                        <button
                            type='button'
                            onClick={onDownloadBudget}
                            className='button hollow'
                            title='Download Borrower Budget'
                        >
                            <FontAwesomeIcon icon={faDownload} />
                        </button>
                    </div>
                </>
            )}
            <ProblemPropertyIndicator
                problemProperty={property.isProblemProperty}
                onChange={onProblemPropertyChange}
            />
            <CreateBudgetModal
                isOpen={isCreateBudgetModalOpen}
                emptyBudgetCallback={emptyBudgetCallback}
                populatedBudgetCallback={populatedBudgetCallback}
                onClose={onCreateBudgetModalClose}
            />
            <ConfirmModal
                isOpen={isSaveModalOpen}
                text='Do you want to save any change before creating the budget?'
                confirmButtonText='Save'
                cancelButtonText='Do not Save'
                confirmCallback={confirmSaveModal}
                cancelCallback={cancelSaveModal}
            />
        </div>
    );
};
